"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BTCOutputAddressType = exports.BTCOutputScriptType = exports.BTCInputScriptType = void 0;
exports.unknownUTXOPath = unknownUTXOPath;
exports.describeUTXOPath = describeUTXOPath;
exports.legacyAccount = legacyAccount;
exports.segwitAccount = segwitAccount;
exports.segwitNativeAccount = segwitNativeAccount;
exports.validateVoutOrdering = validateVoutOrdering;
const bitcoin = __importStar(require("@shapeshiftoss/bitcoinjs-lib"));
const ta = __importStar(require("type-assertions"));
const utils_1 = require("./utils");
ta.assert();
// Bech32 info https://en.bitcoin.it/wiki/BIP_0173
var BTCInputScriptType;
(function (BTCInputScriptType) {
    BTCInputScriptType["CashAddr"] = "cashaddr";
    BTCInputScriptType["Bech32"] = "bech32";
    BTCInputScriptType["SpendAddress"] = "p2pkh";
    BTCInputScriptType["SpendMultisig"] = "p2sh";
    BTCInputScriptType["External"] = "external";
    BTCInputScriptType["SpendWitness"] = "p2wpkh";
    BTCInputScriptType["SpendP2SHWitness"] = "p2sh-p2wpkh";
})(BTCInputScriptType || (exports.BTCInputScriptType = BTCInputScriptType = {}));
var BTCOutputScriptType;
(function (BTCOutputScriptType) {
    BTCOutputScriptType["PayToAddress"] = "p2pkh";
    BTCOutputScriptType["PayToMultisig"] = "p2sh";
    BTCOutputScriptType["Bech32"] = "bech32";
    BTCOutputScriptType["PayToWitness"] = "p2wpkh";
    BTCOutputScriptType["PayToP2SHWitness"] = "p2sh-p2wpkh";
})(BTCOutputScriptType || (exports.BTCOutputScriptType = BTCOutputScriptType = {}));
var BTCOutputAddressType;
(function (BTCOutputAddressType) {
    BTCOutputAddressType["Spend"] = "spend";
    BTCOutputAddressType["Transfer"] = "transfer";
    BTCOutputAddressType["Change"] = "change";
})(BTCOutputAddressType || (exports.BTCOutputAddressType = BTCOutputAddressType = {}));
function unknownUTXOPath(path, coin, scriptType) {
    return {
        verbose: (0, utils_1.addressNListToBIP32)(path),
        coin,
        scriptType,
        isKnown: false,
    };
}
function describeUTXOPath(path, coin, scriptType) {
    const unknown = unknownUTXOPath(path, coin, scriptType);
    if (path.length !== 3 && path.length !== 5)
        return unknown;
    if ((path[0] & 0x80000000) >>> 0 !== 0x80000000)
        return unknown;
    const purpose = path[0] & 0x7fffffff;
    if (![44, 49, 84].includes(purpose))
        return unknown;
    if (purpose === 44 && scriptType !== BTCInputScriptType.SpendAddress)
        return unknown;
    if (purpose === 49 && scriptType !== BTCInputScriptType.SpendP2SHWitness)
        return unknown;
    const wholeAccount = path.length === 3;
    const script = {
        [BTCInputScriptType.SpendAddress]: ["Legacy"],
        [BTCInputScriptType.SpendP2SHWitness]: [],
        [BTCInputScriptType.SpendWitness]: ["Segwit"],
        [BTCInputScriptType.Bech32]: ["Segwit Native"],
    }[scriptType];
    let isPrefork = false;
    const slip44 = (0, utils_1.slip44ByCoin)(coin);
    if (slip44 === undefined)
        return unknown;
    if (path[1] !== 0x80000000 + slip44) {
        switch (coin) {
            case "BitcoinCash":
            case "BitcoinGold": {
                if (path[1] === 0x80000000 + (0, utils_1.slip44ByCoin)("Bitcoin")) {
                    isPrefork = true;
                    break;
                }
                return unknown;
            }
            case "BitcoinSV": {
                if (path[1] === 0x80000000 + (0, utils_1.slip44ByCoin)("Bitcoin") || path[1] === 0x80000000 + (0, utils_1.slip44ByCoin)("BitcoinCash")) {
                    isPrefork = true;
                    break;
                }
                return unknown;
            }
            default:
                return unknown;
        }
    }
    let attributes = isPrefork ? ["Prefork"] : [];
    switch (coin) {
        case "Bitcoin":
        case "Litecoin":
        case "BitcoinGold":
        case "Testnet": {
            if (script)
                attributes = attributes.concat(script);
            break;
        }
        default:
            break;
    }
    const attr = attributes.length ? ` (${attributes.join(", ")})` : "";
    const accountIdx = path[2] & 0x7fffffff;
    if (wholeAccount) {
        return {
            coin,
            verbose: `${coin} Account #${accountIdx}${attr}`,
            accountIdx,
            wholeAccount: true,
            isKnown: true,
            scriptType,
            isPrefork,
        };
    }
    else {
        const change = path[3] === 1 ? "Change " : "";
        const addressIdx = path[4];
        return {
            coin,
            verbose: `${coin} Account #${accountIdx}, ${change}Address #${addressIdx}${attr}`,
            accountIdx,
            addressIdx,
            wholeAccount: false,
            isKnown: true,
            isChange: path[3] === 1,
            scriptType,
            isPrefork,
        };
    }
}
function legacyAccount(coin, slip44, accountIdx) {
    return {
        coin,
        scriptType: BTCInputScriptType.SpendAddress,
        addressNList: [0x80000000 + 44, 0x80000000 + slip44, 0x80000000 + accountIdx],
    };
}
function segwitAccount(coin, slip44, accountIdx) {
    return {
        coin,
        scriptType: BTCInputScriptType.SpendP2SHWitness,
        addressNList: [0x80000000 + 49, 0x80000000 + slip44, 0x80000000 + accountIdx],
    };
}
function segwitNativeAccount(coin, slip44, accountIdx) {
    return {
        coin,
        scriptType: BTCInputScriptType.SpendWitness,
        addressNList: [0x80000000 + 84, 0x80000000 + slip44, 0x80000000 + accountIdx],
    };
}
function validateVoutOrdering(msg, tx) {
    // From THORChain specification:
    /* ignoreTx checks if we can already ignore a tx according to preset rules
  
           we expect array of "vout" for a BTC to have this format
           OP_RETURN is mandatory only on inbound tx
           vout:0 is our vault
           vout:1 is any any change back to themselves
           vout:2 is OP_RETURN (first 80 bytes)
           vout:3 is OP_RETURN (next 80 bytes)
  
           Rules to ignore a tx are:
           - vout:0 doesn't have coins (value)
           - vout:0 doesn't have address
           - count vouts > 4
           - count vouts with coins (value) > 2
        */
    var _a;
    // Check that vout:0 contains the vault address
    if (bitcoin.address.fromOutputScript(tx.outs[0].script) != msg.vaultAddress) {
        console.error("Vout:0 does not contain vault address.");
        return false;
    }
    // TODO: Can we check and  make sure vout:1 is our address?
    // Check and make sure vout:2 exists
    if (tx.outs.length < 3) {
        console.error("Not enough outputs found in transaction.", msg);
        return false;
    }
    // Check and make sure vout:2 has OP_RETURN data
    const opcode = (_a = bitcoin.script.decompile(tx.outs[2].script)) === null || _a === void 0 ? void 0 : _a[0];
    if (Object.keys(bitcoin.script.OPS).find((k) => bitcoin.script.OPS[k] === opcode) != "OP_RETURN") {
        console.error("OP_RETURN output not found for transaction.");
        return false;
    }
    // Make sure vout:3 does not exist
    if (tx.outs[3]) {
        console.error("Illegal second op_return output found.");
        return false;
    }
    return true;
}
//# sourceMappingURL=bitcoin.js.map